export default "__VITE_PUBLIC_ASSET__4b3f7bec__"